import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import BollywoodNews2 from "./BollywoodNews2";
import InternationalDetails2 from "./InternationalDetails2";

const BaseUrl = "https://api.shabdtoday.com/";
const online = "https://api.shabdtoday.com/api/home/getOpinionDetails/";

export default function OpinionDetails() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(online + id);
                setData(res.data.opinionWithMember);
            } catch (err) {
                console.error("Error:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [id]);

    if (loading) return <div style={{ textAlign: "center", padding: "80px", fontSize: "20px", color: "#c10037" }}>लोड हो रहा है...</div>;
    if (!data) return <div style={{ textAlign: "center", padding: "80px", color: "red", fontSize: "18px" }}>ओपिनियन नहीं मिला</div>;

    return (
        <>
            <Helmet>
                <title>{data.opinion_Heading} - ShabdToday</title>
                <meta name="description" content={data.opinion_Description?.slice(0, 160)} />
                <link rel="canonical" href={`https://shabdtoday.com/OpinionDetails/${id}`} />
            </Helmet>

            <div className="ak-post-wrapper">
                <div className="ak-content-wrap ak-post-wrap">
                    <div className="ak-container">
                        <div className="row">
                            {/* Main Content */}
                            <div className="col-md-9">
                                <div className="opinion-details-container">
                                    <h1 className="main-heading">
                                        {data.opinion_Tag && <span className="opinion-tag">{data.opinion_Tag}{data.opinion_Heading}</span>}
                                    </h1>

                                    <div className="main-image-wrapper">
                                        <img src={BaseUrl + data.opinion_Image} alt={data.opinion_Heading} className="main-image" />
                                    </div>

                                    <div className="author-info">
                                        <img src={BaseUrl + data.member_Image} alt={data.member_Name} className="author-img" />
                                        <div className="author-details">
                                            <div className="author-name">{data.member_Name}</div>
                                            <div className="publish-date">
                                                {new Date(data.opinion_Date).toLocaleDateString("hi-IN", {
                                                    day: "numeric",
                                                    month: "long",
                                                    year: "numeric"
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Full Article */}
                                    <div className="opinion-content">
                                        {data.opinion_Description}
                                    </div>
                                </div>
                            </div>

                            {/* Sidebar */}
                            <div className="col-md-3 sidebar-column">
                                <div className="theiaStickySidebar">
                                    <div className="sidebar">
                                        <BollywoodNews2 />
                                        <InternationalDetails2 />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .opinion-details-container { padding: 20px; max-width: 100%; }
                .main-heading {
                    font-size: 30px;
                    font-weight: 800;
                    color: #c10037;
                    line-height: 1.3;
                    margin: 10px 0 20px;
                }
                .opinion-tag {
                    display: block;
                    font-size: 30px;
                    color: #c10037;
                    font-weight: 700;
                    margin-bottom: 8px;
                    text-transform: uppercase;
                }
                .main-image-wrapper {
                    margin: 25px 0;
                    border-radius: 12px;
                    overflow: hidden;
                }
                .main-image { width: 100%; height: auto; display: block; }
                
                .author-info {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    padding: 15px 0;
                    border-bottom: 1px solid #eee;
                    margin-bottom: 25px;
                }
                .author-img {
                    width: 65px;
                    height: 65px;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 4px solid #fff;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
                }
                .author-name { font-weight: 700; font-size: 17px; color: #222; }
                .publish-date { font-size: 14px; color: #888; }

                .opinion-content {
                    font-size: 18.5px;
                    line-height: 1.85;
                    color: #000000;
                    text-align: justify;
                    white-space: pre-line;
                    margin-top: 10px;
                }

                /* Dark Mode - Perfect */
                @media (prefers-color-scheme: dark) {
                    .main-heading, .opinion-tag { color: #ff3366; }
                    .author-info { border-bottom: 1px solid #444; }
                    .author-name { color: #8f8f8f; }
                    .publish-date { color: #bbb; }
                    .opinion-content { color: #8f8f8f; }
                }

                /* Mobile */
                @media (max-width: 768px) {
                    .main-heading { font-size: 24px; }
                    .opinion-content { font-size: 17px; line-height: 1.8; }
                    .author-img { width: 55px; height: 55px; }
                    .sidebar-column { margin-top: 40px; }
                }
            `}</style>
        </>
    );
}